export default __webpack_public_path__ + "static/media/snorkelling.7c2b994c.svg";